import { RootState } from 'src/store';

export const getLmsAuthState = (state: RootState) => state.lmsAuth;

/** LMS login payload in Redux (mirrors persisted session after `loadLmsConfig`). */
export const getLmsConfig = (state: RootState) => state.lmsAuth?.config;

/**
 * Fingerprint of the logged-in LMS session already loaded into Redux.
 * Empty until `loadLmsConfig` has applied a real client + user.
 * Used to detect in-SPA session swaps (e.g. auth redirect) and to invalidate cached UI.
 */
export const getLmsSessionIdentityKey = (state: RootState) => {
  const session = state.lmsAuth?.config;
  if (!session?.client && !session?.user?.code) return '';
  return `${session.client ?? ''}:${session.user?.code ?? ''}:${
    session.email ?? ''
  }`;
};
